var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcOtherReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Edit 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.1627894,5.51900021 L19.4376496,6.24414001 L16.5332333,3.33972369 L17.2583731,2.61458389 C18.0336555,1.83930145 19.387507,1.83930145 20.1627894,2.61458389 C20.5504306,3.00222512 20.7645011,3.51715151 20.7645011,4.06679205 C20.7645011,4.61643259 20.5504306,5.13135899 20.1627894,5.51900021 Z M6.58956095,19.0941572 L2.71700586,20.062296 L3.68514463,16.1897409 L15.0810251,4.79386041 L17.9854414,7.69827673 L6.58956095,19.0941572 Z M21.6149976,1.1643043 C20.0644327,-0.388189152 17.3586584,-0.388189152 15.8061649,1.1643043 L2.03043733,14.9400319 C1.89929502,15.0711742 1.80479542,15.2370306 1.76043846,15.416387 L0.310158869,21.2232911 C0.223373521,21.5723611 0.325587376,21.9426452 0.58015773,22.1991441 C0.774942623,22.393929 1.03722723,22.5 1.30529753,22.5 C1.38822575,22.5 1.47115397,22.4903572 1.55408219,22.469143 L7.36291483,21.0169348 C7.54419978,20.9725779 7.70812766,20.8780783 7.83926996,20.746936 L21.6149976,6.97120837 C22.39028,6.19592593 22.8184211,5.16414457 22.8184211,4.06679205 C22.8184211,2.96943954 22.3922086,1.93958674 21.6149976,1.1643043 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---Report-Options",
    transform: "translate(-23.000000, -559.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Edit-2",
    transform: "translate(22.000000, 558.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    transform: "translate(1.500000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#CCCCCC",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -1.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 26 0 26 26 0 26"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOtherReport);
export default __webpack_public_path__ + "static/media/icOtherReport.83c57004cf1c5572af92d536eb09ddaf.svg";
export { ForwardRef as ReactComponent };